import { useAuth } from "@/hooks/auth/use-auth";

// Guard that waits for /auth/me to resolve before rendering the rest of the app.
export function AuthGate({ children }: { children: React.ReactNode }) {
  const { isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        Loading…
      </div>
    );
  }

  return <>{children}</>;
}
